import { refreshToken } from '../services/apiUsers';
import { DataSim } from './DataSim';
import Cookies from 'js-cookie';

export const getMultipleRandom = (arr) => {
  const randomObject = [...arr].sort(() => 0.5 - Math.random());
  return randomObject;
};
export const totalDiscount = (price, priceOld) => {
  let calcNumber;
  let priceNumber = price.replace(/[^a-zA-Z0-9 ]/g, '');
  let priceOldNumber = priceOld.replace(/[^a-zA-Z0-9 ]/g, '');
  let disCount = priceOldNumber - priceNumber;
  calcNumber = Math.round((disCount / priceOldNumber) * 100) + '%';
  calcNumber = calcNumber === 'NaN%' ? '' : calcNumber;
  return calcNumber;
};
function roundUp(money) {
  const lastDigit = money % 100000;
  let roundedMoney = money;
  if (lastDigit > 50000) {
    roundedMoney += 100000 - lastDigit;
  } else if (lastDigit === 50000) {
    roundedMoney = money;
  } else {
    roundedMoney -= lastDigit;
  }
  return roundedMoney;
}
// export const totalPriceDiscount = (sim, simDiscount) => {
//   let dis = [];
//   console.log(sim.price, simDiscount);
//   simDiscount.map((priceDF) => {
//     if (parseInt(sim.price) >= parseInt(priceDF.price_start) && parseInt(sim.price) <= parseInt(priceDF.price_end)) {
//       const price = numberFormat((sim.price - sim.price * (priceDF.discount / 100)).toString()); //roundUp
//       const pricerose = numberFormat(
//         (sim.price - (sim.price - sim.price * (priceDF.discount / 100))).toString(), // roundUp
//       );
//       dis = [price, pricerose, priceDF.discount];
//     }
//   });

//   return dis;
// };
export const totalPriceDiscount = (sim, simDiscount) => {
  if (!sim?.price) return [];

  const simPrice = parseFloat(sim.price);

  for (const priceDF of simDiscount) {
    const priceStart = parseFloat(priceDF.price_start);
    const priceEnd = parseFloat(priceDF.price_end);

    if (simPrice >= priceStart && simPrice <= priceEnd) {
      const discount = parseFloat(priceDF.discount) || 0;

      // Giá sau khi giảm
      const discountedPrice = Math.round(simPrice - simPrice * (discount / 100));

      // Số tiền giảm
      const discountAmount = Math.round(simPrice - discountedPrice);

      return [
        numberFormat(discountedPrice.toString()), // giá đã giảm
        numberFormat(discountAmount.toString()), // số tiền giảm
        discount, // % chiết khấu
      ];
    }
  }

  // Nếu không có chiết khấu
  return [
    numberFormat(simPrice.toString()), // giá gốc
    numberFormat('0'), // không giảm
    0, // % chiết khấu
  ];
};

export const totalPriceRose = (sim, simDiscount) => {
  let dis;
  simDiscount.map((priceDF) => {
    if (sim.price >= priceDF.price_start && sim.price <= priceDF.price_end) {
      dis = numberFormat((sim.price - (sim.price - sim.price * (priceDF.discount / 100))).toString());
    }
  });
  return dis;
};
export const numberFormat = (number) => {
  let calcNumber;
  let numberPrice = number?.toString()?.replace(/[^a-zA-Z0-9 ]/g, '');
  if (isNaN(numberPrice)) {
    calcNumber = number;
  } else {
    calcNumber = new Intl.NumberFormat('vi-VN', { minimumFractionDigits: 0 }).format(numberPrice);
  }
  return calcNumber;
};

export const numberFormatText = (number) => {
  let num = number?.toString().replace(/[^a-zA-Z0-9 ]/g, '');
  if (isNaN(num)) {
    num = number;
  } else {
    if (num < 1000) {
      return num;
    }
    let si = [
      { v: 1e3, s: 'K' },
      { v: 1e6, s: ' Triệu' },
      { v: 1e9, s: ' Tỷ' },
      { v: 1e12, s: ' T' },
      { v: 1e15, s: ' P' },
      { v: 1e18, s: ' E' },
    ];
    let index;
    for (index = si.length - 1; index > 0; index--) {
      if (num >= si[index].v) {
        break;
      }
    }
    num = (num / si[index].v).toFixed(2).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[index].s;
  }
  return num;
};
export const numberFormatTextShorten = (number) => {
  let num = number?.toString()?.replace(/[^a-zA-Z0-9 ]/g, '');
  if (isNaN(num)) {
    num = number;
  } else {
    if (num < 1000) {
      return num;
    }
    let si = [
      { v: 1e3, s: 'K' },
      { v: 1e6, s: 'Tr' },
      { v: 1e9, s: 'Tỷ' },
      { v: 1e12, s: 'T' },
      { v: 1e15, s: 'P' },
      { v: 1e18, s: 'E' },
    ];
    let index;
    for (index = si.length - 1; index > 0; index--) {
      if (num >= si[index].v) {
        break;
      }
    }
    num = (num / si[index].v).toFixed(2).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[index].s;
  }
  return num;
};
export const numberFormatTextCanvas = (number) => {
  let num = number.replace(/[^a-zA-Z0-9 ]/g, '');
  if (num < 1000) {
    return num;
  }
  let si = [
    { v: 1e3, s: 'K' },
    { v: 1e6, s: ' Tr' },
    { v: 1e9, s: ' Tỷ' },
    { v: 1e12, s: ' T' },
    { v: 1e15, s: ' P' },
    { v: 1e18, s: ' E' },
  ];
  let index;
  for (index = si.length - 1; index > 0; index--) {
    if (num >= si[index].v) {
      break;
    }
  }
  return (num / si[index].v).toFixed(2).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[index].s;
};

export const numberFormatDeleteDots = (number) => {
  let numberPrice = number?.toString().replace(/[^a-zA-Z0-9 ]/g, '');
  // console.log(parseInt(numberPrice));
  // console.log(number.toString().replace(/\./g, ''));
  return parseInt(numberPrice);
};
export const mapRecords = (records, headerData) => {
  return records
    .filter((record) => record.length > 0)
    .map((record) =>
      record.reduce((obj, item, index) => {
        obj[headerData[index]] = item;
        return obj;
      }, {}),
    )
    .slice(1);
};

// tính ý nghĩa đại cat
export const favourite = (number) => {
  const last4Str = String(number).slice(-4);
  const last4Num = parseInt(last4Str);
  const tailnumbers = last4Num / 80;
  const surplus = getDecimalPart(tailnumbers);
  const totalHungCat = '0.' + surplus;
  const total = Math.round(parseFloat(totalHungCat) * 80);
  if (DataSim[total]['mucdo'] === 'Đại Cát' || DataSim[total]['mucdo'] === 'Cát') {
    return DataSim[total];
  } else {
    return '';
  }
};

const getDecimalPart = (num) => {
  // console.log(Number.isInteger(num), num);
  if (Number.isInteger(num)) {
    return 0;
  }

  const decimalStr = num.toString().split('.')[1];
  return parseInt(decimalStr);
};
export const getCookie = (name) => {
  const token = Cookies.get(name);
  if (token) {
    return JSON.parse(decodeURIComponent(atob(token)));
  }
  return null;
};

export const setCookie = (name, item, option) => {
  const encodeData = btoa(encodeURIComponent(JSON.stringify(item)));
  Cookies.set(name, encodeData, option);
};

export const removeCookie = (name) => {
  return Cookies.remove(name);
};

export const getLocalStorage = (name) => {
  const local = localStorage.getItem(name);
  if (local != null) {
    return JSON.parse(decodeURIComponent(atob(local)));
  }
  return null;
};
export const setLocalStorage = (name, item) => {
  const encodeData = btoa(encodeURIComponent(JSON.stringify(item)));
  localStorage.setItem(name, encodeData);
};
export const removeLocalStorage = (name) => {
  return localStorage.removeItem(name);
};
export function fromPrettyParam(str) {
  return str
    ? str
        .replace(/-/g, ' ') // đổi "-" lại thành khoảng trắng
        .trim()
    : null;
}

export function toPrettyParam(str) {
  return str ? str.trim().replace(/\s+/g, '-') : null; // thay khoảng trắng bằng dấu gạch ngang
}

export const checkTokenDashboad = (id = '1') => {
  const nowDate = Math.floor(Date.now() / 1000);
  const getToken = getLocalStorage('token');

  const hostname = window.location.hostname;
  let isStatus = false;
  if (getToken) {
    if (getToken.exp >= nowDate && getToken.link_domain === hostname && getToken.permission === id) {
      if (getToken.exp <= nowDate + 60 * 60 * 24 * 2 && getToken.exp >= nowDate) {
        refresh(getToken.username, hostname);
      }
      isStatus = true;
    } else {
      isStatus = false;
    }
  } else {
    isStatus = false;
  }
  return isStatus;
};

export const refreshTokenNew = () => {
  const getToken = getCookie('token');
  const hostname = window.location.hostname;
  const exp = new Date(getCookie('exp_sv'));
  let nowDate = new Date(new Date().getTime());
  let inFifteenMinutes = new Date(new Date().getTime() + 60 * 60 * 24 * 1000);

  let expInSeconds = Math.floor(exp.getTime() / 1000);
  let nowDateInSeconds = Math.floor(nowDate.getTime() / 1000);
  let inFifteenMinutesInSeconds = Math.floor(inFifteenMinutes.getTime() / 1000);
  if (getToken) {
    if (expInSeconds <= inFifteenMinutesInSeconds && expInSeconds >= nowDateInSeconds) {
      refresh(getToken.username, hostname);
    }
  } else {
    window.location.href = '/user/login';
  }
};

const refresh = async (username, hostname) => {
  let inFifteenMinutes = new Date(new Date().getTime() + 60 * 60 * 24 * 3 * 1000);
  const refresh = await refreshToken({ user: username, domain: hostname });
  Cookies.set('token_sv', refresh['token'], { expires: inFifteenMinutes });
  setCookie('token', refresh['data'], { expires: inFifteenMinutes });
  setCookie('exp_sv', inFifteenMinutes, { expires: inFifteenMinutes });
};

export const removeSpecialCharacters = (str) => {
  // Sử dụng biểu thức chính quy để tìm và thay thế các ký tự đặc biệt
  const regex = /[^0-9]/g;
  const result = str.replace(regex, '');

  return result;
};

// chuyển text -> link
export const convertToSlug = (str) => {
  str = str.toLowerCase();
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a');
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
  str = str.replace(/đ/g, 'd');
  // Some system encode vietnamese combining accent as individual utf-8 characters
  str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ''); // Huyền sắc hỏi ngã nặng
  str = str.replace(/\u02C6|\u0306|\u031B/g, ''); // Â, Ê, Ă, Ơ, Ư
  str = str.replace(/([^\w]+|\s+)/g, '-');
  str = str.replace(/\-\-+/g, '-');
  return str;
};

// lấy dữ liệu cuối cùng
export const getLastValue = (str) => {
  if (str) {
    const parts = str?.split('-');
    const lastPart = parts[parts.length - 1];
    return parseInt(lastPart);
  }
};
export const handleConvertMonths = (number) => {
  const num = parseInt(number);

  if (isNaN(num)) {
    return 'Invalid number';
  }

  if (num < 0) {
    return 'Number must be positive';
  }

  if (num < 30) {
    return `${num} ngày`;
  } else if (num < 360) {
    const months = Math.floor(num / 30);
    return `${months} tháng`;
  } else {
    const years = Math.floor(num / 360);
    return `${years} năm`;
  }
};

const CAN = ['Giáp', 'Ất', 'Bính', 'Đinh', 'Mậu', 'Kỷ', 'Canh', 'Tân', 'Nhâm', 'Quý'];
const CHI = ['Tý', 'Sửu', 'Dần', 'Mão', 'Thìn', 'Tỵ', 'Ngọ', 'Mùi', 'Thân', 'Dậu', 'Tuất', 'Hợi'];

const NAP_AM_60 = [
  { canChi: 'Giáp Tý', menhct: 'Hải Trung Kim', menh: 'kim' },
  { canChi: 'Ất Sửu', menhct: 'Hải Trung Kim', menh: 'kim' },
  { canChi: 'Bính Dần', menhct: 'Lư Trung Hỏa', menh: 'hoa' },
  { canChi: 'Đinh Mão', menhct: 'Lư Trung Hỏa', menh: 'hoa' },
  { canChi: 'Mậu Thìn', menhct: 'Đại Lâm Mộc', menh: 'moc' },
  { canChi: 'Kỷ Tỵ', menhct: 'Đại Lâm Mộc', menh: 'moc' },
  { canChi: 'Canh Ngọ', menhct: 'Lộ Bàng Thổ', menh: 'tho' },
  { canChi: 'Tân Mùi', menhct: 'Lộ Bàng Thổ', menh: 'tho' },
  { canChi: 'Nhâm Thân', menhct: 'Kiếm Phong Kim', menh: 'kim' },
  { canChi: 'Quý Dậu', menhct: 'Kiếm Phong Kim', menh: 'kim' },
  { canChi: 'Giáp Tuất', menhct: 'Sơn Đầu Hỏa', menh: 'hoa' },
  { canChi: 'Ất Hợi', menhct: 'Sơn Đầu Hỏa', menh: 'hoa' },
  { canChi: 'Bính Tý', menhct: 'Giáng Hạ Thủy', menh: 'thuy' },
  { canChi: 'Đinh Sửu', menhct: 'Giáng Hạ Thủy', menh: 'thuy' },
  { canChi: 'Mậu Dần', menhct: 'Thành Đầu Thổ', menh: 'tho' },
  { canChi: 'Kỷ Mão', menhct: 'Thành Đầu Thổ', menh: 'tho' },
  { canChi: 'Canh Thìn', menhct: 'Bạch Lạp Kim', menh: 'kim' },
  { canChi: 'Tân Tỵ', menhct: 'Bạch Lạp Kim', menh: 'kim' },
  { canChi: 'Nhâm Ngọ', menhct: 'Dương Liễu Mộc', menh: 'moc' },
  { canChi: 'Quý Mùi', menhct: 'Dương Liễu Mộc', menh: 'moc' },
  { canChi: 'Giáp Thân', menhct: 'Tuyền Trung Thủy', menh: 'thuy' },
  { canChi: 'Ất Dậu', menhct: 'Tuyền Trung Thủy', menh: 'thuy' },
  { canChi: 'Bính Tuất', menhct: 'Ốc Thượng Thổ', menh: 'tho' },
  { canChi: 'Đinh Hợi', menhct: 'Ốc Thượng Thổ', menh: 'tho' },
  { canChi: 'Mậu Tý', menhct: 'Tích Lịch Hỏa', menh: 'hoa' },
  { canChi: 'Kỷ Sửu', menhct: 'Tích Lịch Hỏa', menh: 'hoa' },
  { canChi: 'Canh Dần', menhct: 'Tùng Bách Mộc', menh: 'moc' },
  { canChi: 'Tân Mão', menhct: 'Tùng Bách Mộc', menh: 'moc' },
  { canChi: 'Nhâm Thìn', menhct: 'Trường Lưu Thủy', menh: 'thuy' },
  { canChi: 'Quý Tỵ', menhct: 'Trường Lưu Thủy', menh: 'thuy' },
  { canChi: 'Giáp Ngọ', menhct: 'Sa Trung Kim', menh: 'kim' },
  { canChi: 'Ất Mùi', menhct: 'Sa Trung Kim', menh: 'kim' },
  { canChi: 'Bính Thân', menhct: 'Sơn Hạ Hỏa', menh: 'hoa' },
  { canChi: 'Đinh Dậu', menhct: 'Sơn Hạ Hỏa', menh: 'hoa' },
  { canChi: 'Mậu Tuất', menhct: 'Bình Địa Mộc', menh: 'moc' },
  { canChi: 'Kỷ Hợi', menhct: 'Bình Địa Mộc', menh: 'moc' },
  { canChi: 'Canh Tý', menhct: 'Bích Thượng Thổ', menh: 'tho' },
  { canChi: 'Tân Sửu', menhct: 'Bích Thượng Thổ', menh: 'tho' },
  { canChi: 'Nhâm Dần', menhct: 'Kim Bạch Kim', menh: 'kim' },
  { canChi: 'Quý Mão', menhct: 'Kim Bạch Kim', menh: 'kim' },
  { canChi: 'Giáp Thìn', menhct: 'Phúc Đăng Hỏa', menh: 'hoa' },
  { canChi: 'Ất Tỵ', menhct: 'Phúc Đăng Hỏa', menh: 'hoa' },
  { canChi: 'Bính Ngọ', menhct: 'Thiên Hà Thủy', menh: 'thuy' },
  { canChi: 'Đinh Mùi', menhct: 'Thiên Hà Thủy', menh: 'thuy' },
  { canChi: 'Mậu Thân', menhct: 'Đại Trạch Thổ', menh: 'tho' },
  { canChi: 'Kỷ Dậu', menhct: 'Đại Trạch Thổ', menh: 'tho' },
  { canChi: 'Canh Tuất', menhct: 'Thoa Xuyến Kim', menh: 'kim' },
  { canChi: 'Tân Hợi', menhct: 'Thoa Xuyến Kim', menh: 'kim' },
  { canChi: 'Nhâm Tý', menhct: 'Tang Đố Mộc', menh: 'moc' },
  { canChi: 'Quý Sửu', menhct: 'Tang Đố Mộc', menh: 'moc' },
  { canChi: 'Giáp Dần', menhct: 'Đại Khê Thủy', menh: 'thuy' },
  { canChi: 'Ất Mão', menhct: 'Đại Khê Thủy', menh: 'thuy' },
  { canChi: 'Bính Thìn', menhct: 'Sa Trung Thổ', menh: 'tho' },
  { canChi: 'Đinh Tỵ', menhct: 'Sa Trung Thổ', menh: 'tho' },
  { canChi: 'Mậu Ngọ', menhct: 'Thiên Thượng Hỏa', menh: 'hoa' },
  { canChi: 'Kỷ Mùi', menhct: 'Thiên Thượng Hỏa', menh: 'hoa' },
  { canChi: 'Canh Thân', menhct: 'Thạch Lựu Mộc', menh: 'moc' },
  { canChi: 'Tân Dậu', menhct: 'Thạch Lựu Mộc', menh: 'moc' },
  { canChi: 'Nhâm Tuất', menhct: 'Đại Hải Thủy', menh: 'thuy' },
  { canChi: 'Quý Hợi', menhct: 'Đại Hải Thủy', menh: 'thuy' },
];

export const getMenhByYear = (number) => {
  const year = Number(number);
  const canIndex = (year + 6) % 10; // Giáp Tý 1984
  const chiIndex = (year + 8) % 12;
  const canChi = `${CAN[canIndex]} ${CHI[chiIndex]}`;

  const menhObj = NAP_AM_60.find((item) => item.canChi === canChi);

  // return menhObj
  //   ? { year, menh: menhObj.menh, menhct: menhObj.menhct }
  //   : { year, menh: 'Không rõ', menhct: 'Không rõ' };

  return menhObj ? menhObj.menh : '';
};
